import http from "e6-base-core/axios/config";

import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_BASE_WEB = "",
  E6_MS_TMS_E6YUN_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//********************* 承运商/客户管理 ****************** */

//获取承运商/客户管理列表数据
export function listCustomerCarrierByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/listCustomerCarrierByPage`,
    method: "post",
    data
  });
}
//新增承运商/客户信息
export function addCustomerCarrier(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/addCustomerCarrier`,
    method: "post",
    data
  });
}

//查询承运商/客户详细信息
export function getCustomerCarrierById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/getCustomerCarrierById`,
    method: "get",
    params
  });
}
//修改承运商/客户信息
export function updateCustomerCarrier(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/updateCustomerCarrier`,
    method: "post",
    data
  });
}
//删除承运商/客户信息
export function deleteCustomerCarrier(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/deleteCustomerCarrier`,
    method: "post",
    data
  });
}

//承运商公司/客户名称唯一性校验
export function findByCustomerCarrierName(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findByCustomerCarrierName`,
    method: "post",
    data
  });
}
//承运商公司/客户代码唯一性校验
export function findByCustomerCarrierCode(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findByCustomerCarrierCode`,
    method: "post",
    data
  });
}
//导出承运商信息
export function exportCarriers(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/exportCarriers`,
    method: "post",
    data
  });
}
//导出客户信息
export function exportCustomers(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/exportCustomers`,
    method: "post",
    data
  });
}
//查询客户、承运商历史记录
export function listCustomerCarrierHistoryByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/listCustomerCarrierHistoryByPage`,
    method: "post",
    data
  });
}
//保存设备关联
export function saveCarrierBindEquip(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/equip/bindEquipAndCarrier`,
    method: "post",
    data
  });
}
//承运商已绑定设备
export function findEquipCarrier(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/equip/getBindEquipList`,
    method: "get",
    params
  });
}
//设备查询
export function getEquipsCarrier(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/equip/getUnbindEquipList`,
    method: "get",
    params
  });
}
//设备查询
export function findEquipTypeList(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/equip/findEquipTypeList`,
    method: "get",
    params
  });
}
//启用承运商/客户信息
export function updateDisable(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/updateDisable`,
    method: "post",
    data
  });
}
